import React from 'react';

import { ReactComponent as Stethoscope } from '@/assets/icons/stethoscope.svg';
import { ReactComponent as Scissors } from '@/assets/icons/scissors.svg';
import { ReactComponent as Medicine } from '@/assets/icons/medicine.svg';
import { ReactComponent as Referral } from '@/assets/icons/referral.svg';
import { ReactComponent as Document } from '@/assets/icons/document.svg';
import { ReactComponent as Drop } from '@/assets/icons/drop.svg';

import { TipoItemComplementar } from '../../models';
import { TipoLabel } from './styles';

const TipoArtefatoIconMapping: {
  [key in TipoItemComplementar]: React.ReactElement;
} = {
  'solicitacao-exame': <Stethoscope />,
  procedimento: <Scissors />,
  'prescricao-medica': <Medicine />,
  encaminhamento: <Referral />,
  'orientacoes-medicas': <Document />,
  manipulado: <Drop />,
};

const TipoArtefatoTextMapping: {
  [key in TipoItemComplementar]: string;
} = {
  'solicitacao-exame': 'Exames',
  procedimento: 'Procedimentos',
  'prescricao-medica': 'Medicamentos',
  encaminhamento: 'Encaminhamentos',
  'orientacoes-medicas': 'Orientações',
  manipulado: 'Manipulados',
};

interface Props {
  tipo: TipoItemComplementar;
  label?: string;
}

const TipoArtefatoLabel: React.FC<Props> = ({ tipo, label }) => {
  const displayLabel = label ?? TipoArtefatoTextMapping[tipo];

  return (
    <>
      {TipoArtefatoIconMapping[tipo]}
      <TipoLabel>{displayLabel}</TipoLabel>
    </>
  );
};

export default TipoArtefatoLabel;
